<div class="authenticating-loader">
  <div class="loading">{{ translationKeys.logoutComponent.usermessage | translate }}</div>
</div>
